import { ApolloLink, Observable } from 'apollo-link';

const is = x => x !== null && x !== undefined;

const isObject = x => is(x) && !Array.isArray(x) && typeof x === 'object';

const isArray = x => is(x) && Array.isArray(x);

const isMappedType = (maps, object) =>
  object.__typename && Object.keys(maps).includes(object.__typename);

const mapArray = (maps, data) => data.map(x => map(maps, x));

const mapTypedObject = (maps, data) => {
  const typeMap = maps[data.__typename];

  return Object.entries(data).reduce((acc, [key, value]) => {
    if (typeMap[key]) {
      acc[key] = typeMap[key](value);
    } else {
      acc[key] = map(maps, value);
    }

    return acc
  }, {})
};

const mapObject = (maps, data) => {
  if (isMappedType(maps, data)) {
    return mapTypedObject(maps, data)
  }

  return Object.entries(data).reduce((acc, [key, value]) => {
    acc[key] = map(maps, value);

    return acc
  }, {})
};

const map = (maps, data) => {
  if (isArray(data)) return mapArray(maps, data)
  if (isObject(data)) return mapObject(maps, data)

  return data
};

const withResponseResolver = maps => {
  return new ApolloLink((operation, forward) => {
    return new Observable(observer => {
      let sub;

      try {
        sub = forward(operation).subscribe({
          next: result => {
            const mapped = map(maps, result.data);
            result.data = mapped;

            observer.next(result);
          },
          error: observer.error.bind(observer),
          complete: observer.complete.bind(observer),
        });
      } catch (e) {
        observer.error(e);
      }

      return () => {
        if (sub) sub.unsubscribe();
      }
    })
  })
};

export { withResponseResolver };
